import React, { useEffect } from 'react';
import zoomToPath from "../../map/utlis/zoomToPath";
import resetZoom from "../../map/utlis/resetZoom";
import t from '../../../utils/t';

const ShopItems = (props) => {
  const { keyword, activeCategory, isMap, mapDispatch, mapState } = props;
  const isMobile = window.innerWidth < 769;

  let stores = isMap ? (mapState.selectedShops || []) : (props.stores || []);

  const getFormattedFloor = (floor) => {
    switch (floor) {
      case -1: {
        return t('stores.attributes.floors.-1')
      }
      case 0: {
        return t('stores.attributes.floors.0')
      }
      case 1: {
        return t('stores.attributes.floors.1')
      }
      case 2: {
        return t('stores.attributes.floors.2')
      }
      default: {
        return ''
      }
    }
  };

  const getItemClassNames = (shop) => {
    const classNames = [
      "mobile-shop-item"
    ];
    if (mapState && mapState.selectedShops && mapState.selectedShops.length === 1) classNames.push('full-width');
    if (mapState && mapState.activeShop && mapState.activeShop.id === shop.id) classNames.push('is-active');

    return classNames.join(" ")
  };

  const handleShopClick = (shop) => {
    if (shop.floor !== mapState.floor) {
      mapDispatch({ type: 'changeFloor', floor: shop.floor })
    }

    if (!document.querySelector('body').className.includes('webview')) {
      mapDispatch({ type: 'setActiveShop', activeShop: shop });
      mapDispatch({ type: 'setActiveShopPreview', activeShopPreview: shop });
    } else {
      mapDispatch({ type: 'setActiveShop', activeShop: shop });
    }
  };

  if (mapState) {
    useEffect(() => {
      if (mapState && mapState.selectedShops && mapState.selectedShops.length === 1) {
        mapDispatch({ type: 'setActiveShop', activeShop: mapState.selectedShops[0] });
        zoomToPath(mapState.selectedShops[0].store_number);
      }
    }, [ mapState.selectedShops ]);
  }

  if (mapState && mapState.activeShopPreview) return null;

  // if (isMap && isMobile && (stores.length > 1 && !activeCategory && keyword.length <= 3)) {
  //   return null;
  // }

  return (
    <div className="mobile-shop-item-wrapper">
      {stores.length <= 0 && keyword && keyword.length > 3 && (
        <div className="no-results">
          <span className="icomoon-sad"/>
          <h4 className="no-results__title">{t('stores.search.no-result')}</h4>
          <p className="no-results__subtitle">{`“${keyword}”`}</p>
        </div>
      )}

      {stores.length <= 0 && activeCategory && keyword.length <= 3 && (
        <div className="no-results">
          <span className="icomoon-sad"/>
          <h4 className="no-results__title">{t('stores.search.no-result-tag')}</h4>
        </div>
      )}

      {stores && stores.map((store, index) => {
        const categories = store.categories;
        const floor = getFormattedFloor(store.floor);
        const className = getItemClassNames(store);
        const mainCategory = categories && categories.length ? categories.find(e => e.is_parent) : null;

        return (
          <a
            key={index}
            className={className}
            href={isMap ? null : store.url}
            onClick={() => {
              handleShopClick(store);
            }}
          >
            <div className="mobile-shop-item__image image">
              <img loading="lazy" src={`${store.logo_url}`}/>
            </div>
            <div className="mobile-shop-item__content">
              <h2 className="mobile-shop-item__title">{store.name}</h2>
              <div className="mobile-shop-item__footer">
                {mainCategory && <span>{mainCategory.translation.title}</span>}
                {floor && <span>{floor}</span>}
              </div>
            </div>
          </a>
        )
      })}
    </div>
  )
};

export default ShopItems;



// WEBPACK FOOTER //
// ./resources/assets/js/components/shop-search/components/ShopItems.jsx